/**
 * Vote Button Component with Up/Down Support
 * 
 * Displays stacked vote buttons with upvote arrow, count, and optional downvote arrow.
 * For logged-out users: buttons remain clickable and trigger auth modal.
 * For logged-in users: direct vote action works.
 */
import { __ } from '@wordpress/i18n';

const VoteButton = ({ 
    upvotes = 0,
    downvotes = 0, 
    hasUpvoted = false, 
    hasDownvoted = false,
    onUpvote, 
    onDownvote,
    isLoggedIn = true,
    isPremium,
    enableDownvoting = false,
    onAuthRequired
}) => {
    // Calculate net votes
    const netVotes = upvotes - downvotes;

    const handleUpvote = (e) => {
        e.stopPropagation();
        if (onUpvote) onUpvote();
    };

    const handleDownvote = (e) => {
        e.stopPropagation();
        if (onDownvote) onDownvote();
    };

    return (
        <div className="cha-vote-stack">
            {/* Upvote Button - Always looks clickable */}
            <button 
                className={`cha-vote-btn cha-vote-up ${hasUpvoted ? 'active' : ''}`}
                onClick={handleUpvote}
                type="button"
                title={hasUpvoted ? __( 'Remove upvote', 'changeloger' ) : __( 'Upvote', 'changeloger' )}
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="16" height="16">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 15l7-7 7 7" />
                </svg>
            </button>
            
            {/* Vote Count */}
            <span className={`cha-vote-count ${netVotes > 0 ? 'positive' : netVotes < 0 ? 'negative' : ''}`}>
                {netVotes}
            </span>
            
            {/* Downvote Button (only if enabled) - Always looks clickable */}
            {enableDownvoting && isPremium && (
                <button 
                    className={`cha-vote-btn cha-vote-down ${hasDownvoted ? 'active' : ''}`}
                    onClick={handleDownvote}
                    type="button"
                    title={hasDownvoted ? __( 'Remove downvote', 'changeloger' ) : __( 'Downvote', 'changeloger' )}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="16" height="16">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                    </svg>
                </button>
            )}
        </div>
    );
};

export default VoteButton;
